
import { useCallback, useState, useMemo, CSSProperties } from 'react'
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';

const MapsCtrl = ({ id, apiKey, lat, lng, onChange }: IGoogleMaps) => {


  // const [map, setMap] = useState(null)

  const containerStyle = {
    width: '100%',
    height: '400px'
  };

  const center: google.maps.LatLngLiteral = {
    lat: lat,
    lng: lng
  };

  const option: google.maps.MapOptions = {
    
    clickableIcons: false,
    disableDoubleClickZoom: true,
    mapTypeControl: false,
    zoom: 17,
    streetViewControl: false,
    restriction: {
      strictBounds: false,
      latLngBounds: {
        north: 15.021697242937783,
        south: 10.958403816615764,
        west:  -87.66238526450299,
        east: -82.8161628421804,
      } as google.maps.LatLngBoundsLiteral
    } as google.maps.MapRestriction
  } as google.maps.MapOptions

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: apiKey ?? ''
  })


   const onLoad = useCallback(function callback(map) {
   const bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);
 }, [])

  const onchange: any = (event: google.maps.MapMouseEvent) => {   
    const lat = event.latLng?.lat();
    const lng = event.latLng?.lng();
    onChange(lat, lng);
  }


  return isLoaded ? (
    <GoogleMap
      id={id}
      mapContainerStyle={containerStyle}
      center={center}
      clickableIcons={true}
      onRightClick={onchange}
      onDblClick={onchange}
      zoom={8}
      onLoad={onLoad}
      //onUnmount={onUnmount}
      options={option}
      

    >
      <Marker position={{ lat: lat, lng: lng }} title='test' draggable={true} onDragEnd={onchange}  animation={0} />
    </GoogleMap>
  ) : <></>
}

export { MapsCtrl }